import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from 'sharedComponents/Avatar';
import { BagIcon, CloseIcon } from 'sharedComponents/Icons';
import { capitalize, getInitials, mapClientContacts } from 'utils';
import { ListItemText, IconButton, ListItemIcon } from '@material-ui/core';
import PropTypes from 'prop-types';

const ClientsListItem = ({ client, onClick, classes, onCloseClick, showBagIndicator }) => {
  const { firstName, lastName, phones, phoneNumbers, phoneNumber, emails, email } = client;
  const onCloseClickHandler = (e) => {
    e.stopPropagation();
    onCloseClick(client);
  };

  return (
    <ListItem disableGutters onClick={onClick} data-testid="client-list-item" className={classes.link}>
      <ListItemAvatar>
        <Avatar className={classes.avatar}>{getInitials(`${firstName} ${lastName}`)}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={`${capitalize(firstName)} ${capitalize(lastName)}`}
        secondary={mapClientContacts(phones || phoneNumbers || phoneNumber, emails || email)}
      />
      {client.conciergeItems && showBagIndicator && (
        <ListItemIcon classes={{ root: classes.menuItemIcon }}>
          <BagIcon className={classes.icon} />
        </ListItemIcon>
      )}
      {onCloseClick && (
        <IconButton classes={{ root: classes.menuItemIcon }} onClick={onCloseClickHandler} data-testid="close-button">
          <CloseIcon className={classes.icon} />
        </IconButton>
      )}
    </ListItem>
  );
};

ClientsListItem.defaultProps = {
  classes: {},
};

ClientsListItem.propTypes = {
  client: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phones: PropTypes.arrayOf(PropTypes.shape({ number: PropTypes.string })),
    phoneNumbers: PropTypes.arrayOf(PropTypes.shape({ number: PropTypes.string })),
    emails: PropTypes.arrayOf(PropTypes.string),
  }),
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.shape({}),
  onCloseClick: PropTypes.func,
  showBagIndicator: PropTypes.bool,
};

export default ClientsListItem;
